import { isCdkProxyConfigured } from '../lib/appConfig';
import { fetchCdkProxy, splitProxyUrl } from '../lib/cdkProxy';

const API_URL = process.env.REACT_APP_NUA_TALKER_CORE;

async function requestDirect({ url, method, data }) {
  const isGet = !method || method.toUpperCase() === 'GET';
  const response = await fetch(`${API_URL}${url}`, {
    method: method || 'GET',
    headers: isGet ? {} : { 'Content-Type': 'application/json' },
    body: isGet ? undefined : JSON.stringify(data),
  });

  if (!response.ok) {
    let errorMsg = `${response.status} ${response.statusText}`;
    try {
      const errBody = await response.json();
      errorMsg = errBody.message || errBody.error || JSON.stringify(errBody);
    } catch (_) {}
    throw new Error(errorMsg);
  }
  const responseData = await response.json();
  return responseData;
}

/**
 * Con `REACT_APP_NUA_PROXY_URL` va a `/nthsms/{hubSpotId}/...` (CDK).
 * En Gen 1 este micro se llamaba `core`. Sin flag, fetch directo.
 * `getClientByTaxId` no lleva tenant: sigue al Core.
 */
async function request({ url, method, data, hubSpotId }) {
  if (isCdkProxyConfigured() && hubSpotId) {
    const { path, queryParams } = splitProxyUrl(url);
    return fetchCdkProxy({
      service: 'nthsms',
      hubSpotId,
      path,
      method: method || 'GET',
      body: data,
      queryParams,
    });
  }
  return requestDirect({ url, method, data });
}

// --- Bolsas de consumo (límites de SMS) ------------------------------------
// Solo lectura desde el front del cliente: la gestión (crear/editar/borrar
// bolsas) es exclusiva del panel de staff (`nuaTalkerNthVoice.service.js`
// tiene el equivalente de Call Blasting, con su propio helper de errores).
// Devuelve { clientId, bags: [{ metric, usedAmount, totalAmount,
// usagePercent, isRecurring, periodStart, periodCount, periodUnit, ... }] }.
// Sin bolsa configurada, `bags` viene vacío (no es un error).

export async function getSmsLimitBags({ clientId }) {
  return request({ url: `/limits/${clientId}`, method: 'GET', hubSpotId: clientId });
}

export async function getLogsByClientId({ queryObject, clientId }) {
  const queryParams = new URLSearchParams(queryObject).toString();

  const response = await request({
    url: `/logs/${clientId}?${queryParams}`,
    method: 'GET',
    hubSpotId: clientId,
  });
  return response;
}

export async function getClientByTaxId({ taxId }) {
  const response = await request({
    url: `/client/taxId/${taxId}`,
    method: 'GET',
  });
  return response;
}

export async function searchLogs({ clientId, body }) {
  const response = await request({
    url: `/logs/${clientId}/search`,
    method: 'POST',
    data: body,
    hubSpotId: clientId,
  });
  return response;
}

export async function countLogsByStatus({ clientId, body }) {
  const response = await request({
    url: `/logs/${clientId}/count`,
    method: 'POST',
    data: body,
    hubSpotId: clientId,
  });
  return response;
}

export async function getBusinessMetrics({ clientId, type, params }) {
  const queryParams = new URLSearchParams(params).toString();
  const response = await request({
    url: `/metrics/${clientId}/business/${type}?${queryParams}`,
    method: 'GET',
    hubSpotId: clientId,
  });
  return response;
}

// --- Bolsas de consumo (límites de SMS) ---------------------------------
// La bolsa se identifica por cliente + métrica: un cliente tiene como mucho
// una bolsa de 'messages' y una de 'sms_parts'.

export async function getLimitBags({ clientId }) {
  return request({ url: `/limits/${clientId}`, method: 'GET', hubSpotId: clientId });
}

export async function createLimitBag({ clientId, bag }) {
  return request({ url: `/limits/${clientId}`, method: 'POST', data: bag, hubSpotId: clientId });
}

export async function updateLimitBag({ clientId, metric, bag }) {
  return request({
    url: `/limits/${clientId}/${metric}`,
    method: 'PUT',
    data: bag,
    hubSpotId: clientId,
  });
}

export async function deleteLimitBag({ clientId, metric }) {
  return request({
    url: `/limits/${clientId}/${metric}`,
    method: 'DELETE',
    hubSpotId: clientId,
  });
}
